import {
  getCookie,
  setCookie,
  CookieKey,
  I18N_LANG_COOKIE_MAP,
  I18N_COOKIE_KEY,
  getLocale,
} from 'mt-shared';
import { IResponseUser, IResponseCompany } from 'mt-shared';
import { DashboardSettings } from '../services/dashboard-settings';

export enum MobileAppCookieValue {
  ANDROID = 'android',
  IOS = 'ios',
}

export enum LOCALE_MODAL_DASHBOARD_KEYS {
  SHOW = 'show-locale-setting-modal',
  SHOW_SESSION = 'show-locale-setting-modal-session',
}

// any changes done here should be reflected in index.ejs.shouldLoadAppMoudle
export function isEmbeddedWebView(): boolean {
  const cookieValue: MobileAppCookieValue = getCookie(CookieKey.KT_MOBILE_APP);
  return !!cookieValue;
}

export function webViewDevice(): MobileAppCookieValue {
  return getCookie(CookieKey.KT_MOBILE_APP);
}

export const isFleetDeviceView: boolean = isEmbeddedWebView() && window.location.href.includes('fleet-devices');

export function seti18nLangCookie(languageInCookie: string, languageFromServer: string): void {
  if (isEmbeddedWebView()) return; // don't set the cookie in embedded view because in that it's provided by mobile

  const expiryDays: number = 90;

  if (languageInCookie) {                                                       // i18n_lang cookie exists
    if (languageInCookie === 'en' && languageFromServer === 'en-US') return;    // do nothing for en, en-US
    else if (languageInCookie !== languageFromServer) {                         // but if (en !== fr-CA, fr-CA !== en-US)
      const lang = (languageFromServer === 'en-US') ? 'en' : languageFromServer;  // lang: en or fr-CA (prefer user lang setting)
      setCookie(I18N_COOKIE_KEY, lang, expiryDays);
    }
  } else {
    const lang = (languageFromServer === 'en-US') ? 'en' : languageFromServer;    // lang: en or fr-CA (prefer user lang setting)
    setCookie(I18N_COOKIE_KEY, lang, expiryDays);
  }
}

export function postLocaleConfirmModelCloseTasks(dashboardSettings: DashboardSettings): void {
  seti18nLangCookie(getCookie(I18N_COOKIE_KEY), getLocale());
  dashboardSettings.setKey(LOCALE_MODAL_DASHBOARD_KEYS.SHOW_SESSION, false);
}

export function showLocalePrompt(dashboardSettings: DashboardSettings): boolean {
  let showPrompt: boolean = false;
  const languageFromServer: string = getLocale();
  const languageInCookie: string = I18N_LANG_COOKIE_MAP[getCookie(I18N_COOKIE_KEY)]; // we need to map 'en-US' with 'en'
  const hasLanguageCookie: boolean = languageInCookie !== undefined;

  // don't show modal in case cookie is not available
  if (hasLanguageCookie) {
    const isLanguageMismatch: boolean = !languageInCookie || languageInCookie !== languageFromServer;
    const showPromptCurrentSession: boolean = dashboardSettings.getKey(LOCALE_MODAL_DASHBOARD_KEYS.SHOW_SESSION);
    const showPromptPermanentSetting: boolean = dashboardSettings.getKey(LOCALE_MODAL_DASHBOARD_KEYS.SHOW);

    // handling case of first time login
    if (showPromptPermanentSetting === undefined) {
      showPrompt = isLanguageMismatch ? true : false;
      dashboardSettings.setKey(LOCALE_MODAL_DASHBOARD_KEYS.SHOW, true);
    } else {
      // when the user logs in after first time
      showPrompt = isLanguageMismatch && showPromptCurrentSession && showPromptPermanentSetting;
    }
  }

  return showPrompt;
}

export function hasZuoraAccountNumber(company: IResponseCompany): boolean {
  if (company && company.z_account_number) return true;
  return false;
}

export function isDashboardLocked(company: IResponseCompany): boolean {
  return company.dashboard_locked;
}

export function isRestrictedToCreditCardUpdateView(user: IResponseUser): boolean {
  const connection = user.company_connection;

  if (connection && connection.company) {
    const company = connection.company;

    return isDashboardLocked(company);
  }

  return false;
}
